import { ModelType } from '../../model/client-model/properties/model-type';
import { NodeListItem } from '../../model/node-list-item';

export function targetHasActiveTransitionTargetData(target: NodeListItem): boolean {
  return (
    !!target.nodeProperties?.transitionElement &&
    target.nodeProperties?.transitionElement ===
      target.nodeProperties?.transitionTargetData?.transitionTargetProperties?.transitionElement &&
    !isNaN(target.nodeProperties.transitionTargetData?.transitionProperties?.targetLevel) &&
    !(target.nodeProperties.modelType === ModelType.CUSTOM)
  );
}
